import axios from 'axios';
import { API } from '@config/common';

export const getUserDevices = () => {
  return axios({
    method: 'get',
    url: `${API.USER_DEVICE}`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
  });
};

export const checkCmdBlockStatus = (userId) => {
  return axios({
    method: 'get',
    url: `${API.USER_DEVICE}${userId}/cmd_block_status`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
  });
};

export const fetchedDeviceVender = (userId) => {
  return axios({
    method: 'get',
    url: `${API.USER_DEVICE}${userId}/vender`,
    headers: { authorization: sessionStorage.getItem('accessToken') },
  });
};

export const editGroupName = (payload) => {
  return axios({
    method: 'put',
    url: `${API.FRANCHISE_DEVICE_GROUP}${payload.id}`,
    headers: {
      authorization: sessionStorage.getItem('accessToken'),
      'content-type': 'application/json',
    },
    params: { id: payload.id },
    data: JSON.stringify({ name: payload.name }),
  });
};
